import * as d3 from "d3";
import { addCommas, genderTooltip, downloadData } from './helpers';
export { stackedBarChart };
import $ from 'jquery';
import * as axios from 'axios';

const tooltip = d3.select("body").append("div")
    .attr("class", "tooltip")

const speed = 750;

function stackedBarChart() {

    const caseData = axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vRb8zyDNZXyPrSgwxUxENm2jKPV-ewDJF_CbEGWvCNuYzXZT_6YwCv209lTeyI6tUIL6jRl6ZWD5Dcv/pub?gid=1704181121&single=true&output=csv")
        .then(content => {
            const justData = content.data
            const pop = d3.csvParse(justData)

            const parseDate = d3.timeParse("%Y-%m-%d");

            pop.forEach((d, i) => {
                d.month = parseDate(d.date);
                d.count = +d.value;
                if (d.group == "Pretrial") { d.group = "En espera de juicio" }
                else if (d.group == "Awaiting State Prison") { d.group = "En espera de prisión estatal" }
                else if (d.group == "Partially Sentenced") { d.group = "Condenados parcialmente" }
                else if (d.group == "Fully Sentenced") { d.group = "Total de condenados" }
                else if (d.group == "Awaiting Mental Health Hospitals") { d.group = "En espera de hospitales de salud mental" }
                else if (d.group == "Parole Revocation") { d.group = "Revocación de la libertad condicional" }
            });
            pop.sort((a, b) => b.month - a.month)

            var currdate = pop[0].date

            const today = pop.filter(d => d.date == currdate)

            const csv = JSON.parse(JSON.stringify(today));

            csv.forEach(function (d) {
                if (d.subgroup == "Flash Incarceration 3454") { d.subgroup = "Violación de supervisión: encarcelamiento “flash”" }
                else if (d.subgroup == "N3 Partially Sentenced") { d.subgroup = "Condenados parcialmente" }
                else if (d.subgroup == "PRCS Revocation 3455") { d.subgroup = "Violación de la supervisión: revocación de la supervisión comunitaria después de la liberación" }
                else if (d.subgroup == "Parole Revocation 3000.08 FPC") { d.subgroup = "Violación de supervisión: revocación de la libertad condicional" }
                else if (d.subgroup == "County Sentenced N3") { d.subgroup = "Condenados totalmente: condenados del condado por un delito de la ley AB 109" }
            })

            csv.sort((a, b) => a.total - b.total)

            const keys = d3.nest()
                .key(d => d.subgroup)
                .entries(csv)
                .map(d => d.key)

            var margin = { top: 15, right: 40, bottom: 0, left: 150 };

            var width = 960 - margin.left - margin.right,
                height = 334 - margin.top - margin.bottom;

            var svg = d3.select("#sentencebarchart")
                .append("svg")
                .attr("width", width + margin.left + margin.right)
                .attr("height", height + margin.top + margin.bottom)
                .append("g")
                .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

            var y = d3.scaleBand()
                .rangeRound([height - margin.bottom, margin.top])
                .padding(0.1)

            // y.domain(csv.map(d => d.group));

            // const initOrder = ["Revocación de la libertad condicional", "En espera de hospitales de salud mental", "Total de condenados", "Condenados parcialmente", "En espera de prisión estatal", "En espera de juicio"]

            // y.domain(initOrder);

            var x = d3.scaleLinear()
                .range([margin.left, width - margin.right])

            var xAxis = svg.append("g")
                .attr("transform", `translate(0,${margin.top + 6})`)
                .attr("class", "x-axis")

            var yAxis = svg.append("g")
                .attr("transform", `translate(${margin.left},0)`)
                .attr("class", "y-axis")

            csv.forEach(function (d) {
                d.value = +d.value;
            })

            update(csv)

            function update(csv) {
                const newdata = d3.nest()
                    .key(d => d.group)
                    .key(d => d.subgroup)
                    .rollup(v => d3.sum(v, d => d.value))
                    .entries(csv);

                // console.log('newdata',newdata)

                const flattenData = newdata.flatMap((item, i) => {
                    const group = item.key;
                    return item.values.map(subgroup => ({
                        group: group,
                        subgroup: subgroup.key,
                        value: subgroup.value
                    }));
                });

                // console.log('flattenData',flattenData)

                // const groupTotals = d3.nest()
                // .key(d => d.group)
                // .rollup(v => d3.sum(v, d => d.value))
                // .object(flattenData)

                // const groupTotalGroups = Object.keys(groupTotals);
                // const groupTotalValues = Object.values(groupTotals);

                const totalPop = d3.nest()
                    .rollup(v => d3.sum(v, d => d.value))
                    .object(flattenData)

                const data = d3.nest()
                    .key(d => d["group"])
                    .rollup(function (d) {
                        return d.reduce(function (prev, curr) {
                            prev["group"] = curr["group"];
                            prev["sex"] = curr["sex"];
                            prev[curr["subgroup"]] = +curr["value"];
                            return prev;
                        }, {});
                    })
                    .entries(flattenData)
                    .map(d => d.value)

                data.forEach(function (d) {
                    d.total = d3.sum(keys, k => +d[k])
                    return +d
                })

                downloadData('data-download-sentence-bar', data, 'dailysubsentencedata.csv')

                data.sort((a, b) => a.total - b.total)

                x.domain([0, d3.max(data, d => d3.sum(keys, k => +d[k]))]).nice();

                y.domain(data.map(d => d.group));

                svg.selectAll(".y-axis").transition().duration(speed)
                    .call(d3.axisLeft(y).ticks(null, "s"))

                svg.selectAll(".x-axis").transition().duration(speed)
                    .call(d3.axisTop(x).tickSizeOuter(0).ticks(4))

                var group = svg.selectAll("g.layer")
                    .data(d3.stack().keys(keys)(data), d => d.key)

                group.exit().remove()

                group.enter().append("g")
                    .classed("layer", true)

                var bars = svg.selectAll("g.layer").selectAll("rect")
                    .data(d => d, e => e.data.group);

                bars.exit().remove()

                bars.enter().append("rect")
                    .attr('fill', '#EF4136')
                    .attr('stroke', '#fff')
                    .merge(bars)
                    // .on("mouseover", function (d) {
                    //     let subSentencePopulations = Object.values(d.data)
                    //     let subSentenceGroupIndex = subSentencePopulations.indexOf(d[1] - d[0])
                    //     let subSentenceGroup = Object.keys(d.data)[subSentenceGroupIndex]

                    //     // let groupIndex = groupTotalGroups.indexOf(d.data.group)
                    //     // let groupTotal = groupTotalValues[groupIndex]
                    //     let whichPopulation = $(".genderbuttona.selected").text()
                    //     let population
                    //     if (whichPopulation == "All") { population = "total" }
                    //     else if (whichPopulation == "Females") { population = "female" }
                    //     else if (whichPopulation == "Males") { population = "male" }

                    //     var tooltip_str = subSentenceGroup + ': ' + addCommas(d[1] - d[0]) + '<br/>'
                    //         + (((d[1] - d[0]) / totalPop) * 100).toFixed(1) + '% of ' + population + ' jail population'
                    //     // + (((d[1] - d[0])/groupTotal)*100).toFixed(1) + '% of total jail population'

                    //     tooltip.html(tooltip_str)
                    //         .style("visibility", "visible");
                    // })
                    // .on("mousemove", function (d) {
                    //     tooltip.style("top", event.pageY - (tooltip.node().clientHeight + 5) + "px")
                    //         .style("left", event.pageX - (tooltip.node().clientWidth / 2.0) + "px");
                    // })
                    // .on("mouseout", function (d) {
                    //     tooltip.style("visibility", "hidden");
                    // })
                    .transition().duration(speed)
                    .attr("width", d => x(d[1]) - x(d[0]))
                    .attr("y", d => y(d.data.group))
                    .attr("x", d => x(d[0]))
                    .attr("height", y.bandwidth());

                var text = svg.selectAll(".text")
                    .data(data, d => d.group);

                text.exit().remove()

                text.enter().append("text")
                    .attr("class", "text")
                    .attr("text-anchor", "middle")
                    .merge(text)
                    .transition().duration(speed)
                    .attr("y", d => y(d.group) + y.bandwidth() / 2)
                    .attr("x", d => x(d.total) + 25)
                    .text(d => addCommas(d.total))
            }


            d3.selectAll(".genderbuttona").on("click", function () {
                let data;
                var selectedVariable = d3.select(this).attr("id");
                if (d3.select(this).classed("selected")) {
                } else {
                    d3.selectAll(".genderbuttona").classed("selected", false);
                    d3.select(this).classed("selected", true);
                }
                if (selectedVariable == 'All') { data = csv } else {
                    data = csv.filter(d => d.sex == selectedVariable)
                }
                update(data)

            })

        })
}
genderTooltip()
